import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';
import { toast } from 'sonner';

const ChatContext = createContext();

export function ChatProvider({ children }) {
  const [chats, setChats] = useState([]);
  const [activeChatId, setActiveChatId] = useState('');
  const [deleteChatId, setDeleteChatId] = useState('');

  const createChat = async () => {
    const res = await api.chat.createChat();
    const chatId = res.chat_id;
    setActiveChatId(chatId);
    return res;
  };

  // Get History OF chats
  const getChatHistory = async () => {
    try {
      const res = await api.chat.getChatHistory(); // no payload
      setChats(res.chats); // assuming res is an array of chats
      return res;
    } catch (err) {
      console.error('Failed to fetch chat history', err);
      toast.error('Error While Fetching the history!');
    }
  };

  // Get chats by ID
  const getChatsById = async (chatId) => {
    try {
      const res = await api.chat.getMessages(chatId); // no payload
      return res;
    } catch (err) {
      console.error('Failed to fetch chats', err);
      toast.error('Error While Fetching the chats!');
    }
  };

  // Rename Chat
  const renameChatById = async (chatId, name) => {
    const res = await api.chat.renameChat(chatId, name);
    return res;
  };

  const deleteChatById = async (chatId) => {
    const res = await api.chat.deleteChat(chatId);
    return res;
  };

  useEffect(() => {
    if (!activeChatId) return;
  }, [activeChatId]);

  return (
    <ChatContext.Provider
      value={{
        chats,
        activeChatId,
        createChat,
        setActiveChatId,
        getChatHistory,
        renameChatById,
        getChatsById,
        deleteChatId,
        setDeleteChatId,
        deleteChatById,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}

export const useChat = () => useContext(ChatContext);
